'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _dec, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = require('react-i18next');

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _Button = require('components/Button/Button');

var _Button2 = _interopRequireDefault(_Button);

var _SongsSelectPopup = require('components/SongsSelectPopup/SongsSelectPopup');

var _SongsSelectPopup2 = _interopRequireDefault(_SongsSelectPopup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var SongsSelectButton = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_class2 = (_temp = _class3 = function (_PureComponent) {
  (0, _inherits3.default)(SongsSelectButton, _PureComponent);

  function SongsSelectButton() {
    var _ref;

    (0, _classCallCheck3.default)(this, SongsSelectButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = SongsSelectButton.__proto__ || (0, _getPrototypeOf2.default)(SongsSelectButton)).call.apply(_ref, [this].concat(args)));

    _this.state = { showSongsPopup: false };
    return _this;
  }

  (0, _createClass3.default)(SongsSelectButton, [{
    key: 'onSave',
    value: function onSave(songs) {
      var onSave = this.props.onSave;

      onSave(songs);
    }
  }, {
    key: 'showSongsSelectPopup',
    value: function showSongsSelectPopup() {
      this.setState({ showSongsPopup: true });
    }
  }, {
    key: 'hideSongsPopup',
    value: function hideSongsPopup() {
      this.setState({ showSongsPopup: false });
    }
  }, {
    key: 'render',
    value: function render() {
      var t = this.props.t;
      var showSongsPopup = this.state.showSongsPopup;


      return _react2.default.createElement(
        _Button2.default,
        { className: 'btn-primary', onClick: this.showSongsSelectPopup },
        t('Add songs'),
        _react2.default.createElement(_SongsSelectPopup2.default, {
          show: showSongsPopup,
          onHide: this.hideSongsPopup,
          onSave: this.onSave
        })
      );
    }
  }]);
  return SongsSelectButton;
}(_react.PureComponent), _class3.propTypes = {
  onSave: _propTypes2.default.func,
  t: _propTypes2.default.func
}, _class3.defaultProps = {
  onSave: _noop3.default
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onSave', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onSave'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'showSongsSelectPopup', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'showSongsSelectPopup'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'hideSongsPopup', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'hideSongsPopup'), _class2.prototype)), _class2)) || _class);
exports.default = SongsSelectButton;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SongsSelectButton/SongsSelectButton.js
// module id = 2101
// module chunks = 1